<template>
    <el-dialog :title="$t('serviceTickets.createServiceTicket')"
               :visible.sync="showDialog"
               @close="closeDialog"
               width="60%"
               :close-on-click-modal="false">
        <el-form :disabled="isSavingInProgress"
                 v-loading="loading"
                 ref="form"
                 :model="form"
                 :rules="rules"
                 size="small"
                 label-width="140px"
                 label-position="left">
            <el-form-item :label="$t('serviceTickets.ticketNumber')">
                <el-input v-model="serviceTicketNumber"
                          disabled
                          type="number"></el-input>
            </el-form-item>
            <el-form-item :label="$t('serviceTickets.customer')"
                          prop="customerId"
                          class="Customer">
                <customer-selector v-if="!copyticket" v-model="form.customerId"></customer-selector>
            </el-form-item>
            <el-row>
                <el-col :span="14">
                    <el-form-item :label="$t('serviceTickets.product')"
                                  prop="equipmentId">
                        <equipment-selector v-model="form.equipmentId"
                                            :customerId="form.customerId" @equipmentSelected="equipmentSelected"></equipment-selector>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item :label="$t('serviceTickets.warrantyEnd')" style="float:right;">
                        <el-input v-model="equipmentWrtEnd"
                                  disabled
                                  type="text"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item :label="$t('serviceTickets.callerTitle')"
                          prop="callerTitle">
                <el-select v-if="!copyticket" v-model="form.callerTitle"
                           class="full-width">
                    <el-option :value="15"
                               label="Food Court Manager"></el-option>
                    <el-option :value="1"
                               :label="$t('serviceTickets.deliManager')"></el-option>
                    <el-option :value="14"
                               :label="$t('serviceTickets.deliSupervisor')"></el-option>
                    <el-option :value="2"
                               :label="$t('serviceTickets.meatManager')"></el-option>
                    <el-option :value="3"
                               :label="$t('serviceTickets.regionalManager')"></el-option>
                    <el-option :value="4"
                               :label="$t('serviceTickets.hardtManager')"></el-option>
                    <el-option :value="5"
                               :label="$t('serviceTickets.hardtProductManager')"></el-option>
                    <el-option :value="6"
                               :label="$t('serviceTickets.warehouseManager')"></el-option>
                    <el-option :value="7"
                               :label="$t('serviceTickets.warehouseManagerAssistant')"></el-option>
                    <el-option :value="8"
                               :label="$t('serviceTickets.operator')"></el-option>
                    <el-option :value="9"
                               :label="$t('serviceTickets.customerCorporateRequest')"></el-option>
                    <el-option :value="10"
                               :label="$t('serviceTickets.maintance')"></el-option>
                    <el-option :value="11"
                               :label="$t('serviceTickets.freshManager')"></el-option>
                    <el-option :value="12"
                               :label="$t('serviceTickets.freshManagerAssistant')"></el-option>
                    <el-option :value="13"
                               :label="$t('serviceTickets.other')"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('serviceTickets.callerName')"
                          prop="caller">
                <el-input v-model="form.caller"></el-input>
            </el-form-item>
            <el-form-item :label="$t('serviceTickets.callerPhone')"
                          prop="callerPhoneNumber">
                <el-input v-model="form.callerPhoneNumber" v-mask="'(###) ###-####'"></el-input>
            </el-form-item>
            <el-form-item :label="$t('serviceTickets.urgency')"
                          prop="urgency">
                <el-select v-if="!copyticket" v-model="form.urgency"
                           class="full-width">
                    <el-option :value="7"
                               :label="$t('serviceTickets.escalation')"></el-option>
                    <el-option :value="1"
                               :label="$t('serviceTickets.priorityDown')"></el-option>
                    <el-option :value="2"
                               :label="$t('serviceTickets.priorityOperational')"></el-option>
                    <el-option :value="3"
                               :label="$t('serviceTickets.installation')"></el-option>
                    <el-option :value="4"
                               :label="$t('serviceTickets.postInstallation')"></el-option>
                    <el-option :value="5"
                               :label="$t('serviceTickets.installPostInstallCombo')"></el-option>
                    <el-option :value="6"
                               :label="$t('serviceTickets.hold')"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('serviceTickets.status')"
                          prop="status">
                <el-select v-model="form.status"
                           class="full-width">
                    <el-option :value="1"
                               label=" "></el-option>
                    <el-option :value="3"
                               :label="$t('common.flagged')"></el-option>
                    <el-option :value="5"
                               :label="$t('common.escalation')"></el-option>
                    <el-option :value="8"
                               label="Standard"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item  :label="$t('serviceTickets.serviceCoverage')"
                          prop="serviceCoverage">
                <el-select v-if="!copyticket" v-model="form.serviceCoverage"
                           class="full-width">
                    <el-option :value="1"
                               :label="$t('serviceTickets.warranty')"></el-option>
                    <el-option :value="2"
                               :label="$t('serviceTickets.costcoNonWarranty')"></el-option>
                    <el-option :value="3"
                               :label="$t('serviceTickets.costcoPreventativeMaintenance')"></el-option>
                    <el-option :value="4"
                               :label="$t('serviceTickets.wallMartNonWarranty')"></el-option>
                    <el-option :value="5"
                               :label="$t('serviceTickets.pendingWarranty')"></el-option>
                    <el-option :value="6"
                               :label="$t('serviceTickets.warrantyException')"></el-option>
                    <el-option :value="7"
                               :label="$t('serviceTickets.installationPostInstallation')"></el-option>
                    <!--
                    <el-option :value="8"
                               :label="$t('serviceTickets.nonWarranty')"></el-option>
                    -->
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('serviceTickets.overtimeApproved')"
                          prop="overtimeApproved">
                <el-select v-model="form.overtimeApproved"
                           class="full-width">
                    <el-option :value="true" label="Yes" />
                    <el-option :value="false" label="No" />
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('serviceTickets.communicationRequirements')"
                          prop="notes">
                <el-input type="textarea"
                          v-model="form.notes"></el-input>
            </el-form-item>
            <el-row v-if="!!form.equipmentNote">
                <el-col >
                    <el-form-item :label="$t('serviceTickets.productNote')"
                                    style="background-color: yellow; padding:2px;">
                        <el-input type="textarea" 
                          autosize
                          v-model="form.equipmentNote" disabled></el-input>
                    </el-form-item>
                </el-col>
                
            </el-row>
            <el-form-item :label="$t('serviceTickets.responseTime')"
                          prop="responseTime">
                <el-select v-model="form.responseTime"
                           class="full-width">
                    <el-option :value="-1"
                               label=" "></el-option>
                    <el-option :value="2"
                               label="2 hrs"></el-option>
                    <el-option :value="4"
                               label="4 hrs"></el-option>
                    <el-option :value="6"
                               label="6 hrs"></el-option>
                </el-select>
            </el-form-item>
            <h4>{{$t('serviceTickets.symptoms')}}</h4>
            <span style="display:flex; justify-content:space-around;">
                <el-form-item :label="$t('serviceTickets.selectCategory')" prop="categoryName">
                    <el-select v-model="form.categoryName" class="select" clearable filterable :placeholder="$t('serviceTickets.pleaseSelectCategory')">
                        <el-option v-for="item in form.categories" :label="item.category" :value="item.category"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="form.subCategories && form.subCategories.length >  0 && form.equipmentName && form.equipmentName.includes('I4500')" :label="$t('serviceTickets.selectSubcategory')" prop="subCategoryName" style="margin-left:30px;">
                    <el-select v-model="form.subCategoryName" class="select" clearable filterable :placeholder="$t('serviceTickets.pleaseSelectSubcategory')">
                        <el-option v-for="item in form.subCategories" v-if="form.categoryName" :label="item" :value="item"></el-option>
                    </el-select>
                </el-form-item>
            </span>
            <el-form-item :label="$t('serviceTickets.addSymptom')">
                <complaint-code-selector :equipmentId="form.equipmentId"
                                         :categoryName="form.categoryName"
                                         :subCategoryName="form.subCategoryName"
                                         @code-selected="appendCode"></complaint-code-selector>
            </el-form-item>
            <el-alert @close="removeCode(complaint.id)"
                      :key="complaint.id"
                      v-for="complaint in form.complaintCodes"
                      :title="complaint.name"
                      type="info"
                      style="margin-bottom: 5px">
            </el-alert>
            <el-form-item :label="$t('serviceTickets.previousCalls')"
                          v-if="previousTickets.length > 0">
                <el-table :disabled="isSavingInProgress" :data="previousTickets" class="tablewithshading">
                    <el-table-column prop="raisedOn"
                                     :label="$t('serviceTickets.date')"></el-table-column>
                    <el-table-column prop="id"
                                     :label="$t('serviceTickets.ticketNumber')"
                                     width="100"></el-table-column>
                    <el-table-column prop="serialNumber"
                                     :label="$t('serviceTickets.serialNumber')"></el-table-column>
                    <el-table-column prop="note"
                                     :label="$t('serviceTickets.description')"
                                     min-width="300"></el-table-column>
                    <el-table-column prop="status"
                                     :label="$t('serviceTickets.status')"
                                     width="100"></el-table-column>
                    <el-table-column :label="$t('serviceTickets.view')"
                                     width="100">
                        <template slot-scope="scope">
                            <el-button size="mini"
                                       @click="editTicket(scope.row.id)">
                                <i class="el-icon-view"></i>
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="display: flex; justify-content: center; margin-top: 10px;">
                    <el-button v-if="!previousTicketsButtonDisabled"
                               @click="getMorePreviousTickets()">
                        Load More
                    </el-button>
                </div>
            </el-form-item>
            <el-form-item :label="$t('serviceTickets.ticketFiles')"
                          prop="attachments">
                <el-upload name="attachments"
                           drag
                           multiple
                           :file-list="form.attachments"
                           :auto-upload="false"
                           :limit="10"
                           action=""
                           :on-change="attachmentChanged"
                           :on-preview="handlePreview">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">
                        {{$t('serviceTickets.dropFile')}}
                        <em>{{$t('serviceTickets.clicktoUpload')}}</em>
                    </div>
                </el-upload>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <el-button type="success"
                       :disabled="isSavingInProgress && !isCopy"
                       :loading="isSavingInProgress && isCopy"
                       @click="copyAndSave">{{$t('serviceTickets.copyAndSave')}}</el-button>
            <el-button type="primary"
                       :loading="isSavingInProgress && !isCopy"
                       :disabled="isSavingInProgress && isCopy"
                       @click="showEmailDialog">{{$t('serviceTickets.save')}}</el-button>
            <el-button :disabled="isSavingInProgress"
                       @click="close">{{$t('serviceTickets.close')}}</el-button>
            <el-button :disabled="isSavingInProgress"
                       @click="closeDialog">{{$t('serviceTickets.cancel')}}</el-button>
        </span>
        <el-dialog :visible.sync="showImagePreview"
                   width="60%"
                   append-to-body>
            <embed v-bind:src="fileUrlPreview"
                   style="width: 100%; height: 600px;"
                   type='application/pdf'>
            <el-button @click="showImagePreview = false">{{$t('serviceTickets.close')}}</el-button>
        </el-dialog>
        <send-email-dialog :visible="showSaveDialog" :loadingChangeEmail="loadingChangeEmail" :formChangeEmail="formChangeEmail" @save="save"></send-email-dialog>
        <duplicate-ticket-warning :visible="showDuplicateTicketWarning" :existingTicketId="existingTicketId" :existingTicketDate="existingTicketDate" @close="handleDialogClose" @cancel="handleDialogCancel" @continue="handleDialogContinue" />
        <el-dialog :visible.sync="showRsMessage"
                   width="30%"
                   append-to-body
                   :title="$t('serviceTickets.customerRs')">
            <p>
                {{$t('serviceTickets.rsMessage1')}}<br>
                {{$t('serviceTickets.rsMessage2')}}
            </p>
            <el-button @click="showRsMessage = false">{{$t('serviceTickets.ok')}}</el-button>
            <el-button @click="viewrsprocedures">{{$t('serviceTickets.viewRsProcedures')}}</el-button>
        </el-dialog>
        <service-ticket-details-dialog :ticketId="ticketToEdit"
                                       :visible="dialogVisible"
                                       @dialogClosed="editFinished"></service-ticket-details-dialog>
    </el-dialog>
</template>

<script>
    import {
        CustomerSelector,
        EquipmentSelector,
        ComplaintCodeSelector,
        CategorySelector
    } from "@/app/shared/components";
    import ServiceTicketDetailsDialog from "./ServiceTicketDetailsDialog";
    import SendEmailDialog from "./SendEmailDialog";
    import DuplicateTicketWarning from "./DuplicateTicketWarning";
    import api from "../api";
    export default {
        name: "create-service-ticket-dialog",
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            ticketId: {
                type: Number
            }
        },
        components: {
            CustomerSelector,
            EquipmentSelector,
            ComplaintCodeSelector,
            CategorySelector,
            ServiceTicketDetailsDialog,
            SendEmailDialog,
            DuplicateTicketWarning
        },

        data() {
            return {
                showDuplicateTicketWarning: false,
                existingTicketId: '',
                existingTicketDate: '',
                dialogVisible: false,
                isSavingInProgress: false,
                showRsMessage: false,
                serviceCoverageName: undefined,
                callerTitleValue: undefined,
                urgencyValue: undefined,
                copyticket: false,
                isCopy: false,
                form: {
                    customerName: undefined,
                    customerId: undefined,
                    equipmentId: undefined,
                    categoryName: undefined,
                    equipmentName: undefined,
                    subCategoryName: undefined,
                    callerTitle: undefined,
                    caller: "",
                    callerPhoneNumber: "",
                    overtimeApproved: undefined,
                    isConfirmationOnly: false,
                    urgency: undefined,
                    notes: "",
                    status: undefined,
                    serviceCoverage: undefined,
                    complaintCodes: [],
                    attachments: [],
                    categories: [],
                    subCategories: [],
                    responseTime: -1
                },
                rules: {
                    customerId: [
                        {
                            type: "number",
                            required: true,
                            message: this.$t('shared.pleaseSelectCustomer'),
                            trigger: "change"
                        }
                    ],
                    equipmentId: [
                        {
                            type: "number",
                            required: true,
                            message: this.$t('common.pleaseSelectEquipment'),
                            trigger: "change"
                        }
                    ],
                    callerTitle: [
                        {
                            type: "number",
                            required: true,
                            message: this.$t('common.pleaseSelectTitle'),
                            trigger: "change"
                        }
                    ],
                    caller: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterCallerName'),
                            trigger: "blur"
                        }
                    ],
                    urgency: [
                        {
                            type: "number",
                            required: true,
                            message: this.$t('common.pleaseSelectUrgency'),
                            trigger: "change"
                        }
                    ],
                    serviceCoverage: [
                        {
                            type: "number",
                            required: true,
                            message: this.$t('shared.pleaseSelectServiceCoverage'),
                            trigger: "change"
                        },
                    ],
                    overtimeApproved: [
                        {
                            required: true,
                            message: "Please select overtime approved",
                            trigger: "change"
                        }
                    ],
                    overtimeApproved: [
                        {
                            required: true,
                            message: this.$t('shared.pleaseSelectOvertimeApproved'),
                            trigger: "change"
                        }
                    ],
                },
                formChangeEmail: {
                    serviceCompany: null,
                    phone: null,
                    email: null,
                    useCustom: false
                },
                loading: false,
                showDialog: this.visible,
                fileUrlPreview: null,
                showImagePreview: false,
                serviceTicketNumber: null,
                previousTickets: [],
                showSaveDialog: false,
                loadingChangeEmail: false,
                ticketToEdit: null,
                equipmentWrtEnd: null,
                currentPreviousTicketsPage: 1,
                previousTicketsPageSize: 4,
                previousTicketsTotal: 0,
                previousTicketsButtonDisabled: false
            };
        },
        watch: {
            "form.customerId": function (val, oldVal) {
                if (this.form.customerId) {
                    api.customerIsRs(this.form.customerId).then(response => {
                        if (response && response.data && response.data === true) {
                            this.showRsMessage = true;
                        }
                    });
                }
                this.getServiceCompanyCredentials();
                if (this.form.customerId && oldVal === undefined) {
                    return;
                }
                this.form.equipmentId = undefined;
            },
            "form.equipmentId": function (val, oldVal) {
                if (val != undefined && val != null && val != "") {
                    api.getPreviousTickets(val, this.previousTicketsPage, this.previousTicketsPageSize).then(response => {
                        this.previousTickets = response.data.items;
                        this.previousTicketsTotal = response.data.total;
                        if (response.data.items.length < this.previousTicketsPageSize || response.data.items.length === response.data.total) {
                            this.previousTicketsButtonDisabled = true;
                        }
                    });
                }
            },
            "form.categoryName": function (val) {
                if (val != undefined && val != null && val != "") {
                    this.form.subCategories = this.form.categories.filter(e => e.category == val)[0].subCategories;
                    this.form.subCategoryName = undefined;
                }
                else {
                    this.form.subCategories = [];
                    this.form.subCategoryName = undefined;
                }
            },
            "form.status": function (val, oldVal) {
                switch (val) {
                    case 1:
                        this.form.notes = "";
                        break;
                    case 3:
                        this.form.notes = this.$t('common.flaggedCall');
                        break;
                    case 5:
                        this.form.notes = this.$t('common.escalationNotes');
                        break;
                    case 8:
                        this.form.notes = this.$t('common.callCustomer');
                        break;
                }
            },
            visible: function (val) {
                this.showDialog = val;
            }
        },
        methods: {
            scrollToElement(options) {
                const el = this.$el.getElementsByClassName('Customer')[0];

                if (el) {
                    el.scrollIntoView(options);
                }
            },
            loadTicket()
            {
                if (this.ticketId)
                {
                    this.loading = true;
                    api.getTicket(this.ticketId).then(response =>
                    {
                        this.loading = false;
                        console.log(response.data);
                        if (response.data.success)
                        {
                            response.data.ticket['caller'] = response.data.ticket.callBy.split("(")[0];
                            this.form = Object.assign({}, response.data.ticket);

                            this.form.serviceCoverage = response.data.ticket.coverageNumber;
                            this.serviceCoverageName = response.data.ticket.coverageName;

                            this.form.callerTitle = Number(response.data.ticket.callerTitle);
                            this.callerTitleValue = response.data.ticket.callerTitleValue;

                            this.urgencyValue = response.data.ticket.urgencyValue;
                            this.form.urgency = response.data.ticket.urgencyNumber;

                            this.form.complaintCodes = [];
                            this.form.categories = [];
                            this.form.status = '';

                            this.copyticket = true;
                            api.getServiceTicketNumber().then(response =>
                            {
                                this.loading = false;
                                this.serviceTicketNumber = response.data.data;
                            });
                            api.getComplaintCodeCategories().then(response =>
                            {
                                this.loading = false
                                this.form.categories = response.data
                            });

                        } else
                        {
                            this.$notify({
                                title: "Error",
                                message: response.data.message,
                                type: "error"
                            });
                            this.copyticket = false;
                        }
                    });
                }
            },
            appendCode(code) {
                if (this.form.complaintCodes.indexOf(code) === -1) {
                    this.form.complaintCodes.push(code);
                }
            },
            removeCode(code)
            {
                this.form.complaintCodes = this.form.complaintCodes.filter(
                    c => c.id != code
                );  
            },
            closeDialog() {
                api.getServiceTicketNumber().then(response => {
                    this.loading = false;
                    this.serviceTicketNumber = response.data.data;
                });
                this.formChangeEmail.serviceCompany = null;
                this.formChangeEmail.phone = null;
                this.formChangeEmail.email = null;
                this.formChangeEmail.useCustom = false;
                this.$refs["form"].resetFields();
                this.form.complaintCodes = [];
                this.showDialog = false;
                this.previousTickets = [];
                this.loading = false;
                this.showSaveDialog = false;
                this.isCopy = false;
                this.isSavingInProgress = false;
                this.$emit("dialogClosed");
                this.previousTicketsTotal = 0;
                this.previousTicketsButtonDisabled = false;
                this.currentPreviousTicketsPage = 1;
            },
            save(sendEmail, isEmailFormValied) {
                this.showSaveDialog = false;
                this.$refs["form"].validate(valid => {
                    if (valid) {
                        this.$refs["form"].loading = true;
                        this.isSavingInProgress = true;
                        this.form.status = this.form.status || "1"; // service ticket opened value
                        if (this.formChangeEmail.useCustom) {
                            if (isEmailFormValied) {
                                api
                                    .saveTicket(
                                        sendEmail,
                                        this.form,
                                        this.serviceTicketNumber,
                                        this.formChangeEmail
                                    )
                                    .then(() => {
                                        this.$notify({
                                            title: this.$t('common.success'),
                                            message: this.$t('common.ticketSuccessfullySaved'),
                                            type: "success"
                                        });
                                        this.closeDialog();
                                    })
                                    .catch(response => {
                                        this.$notify({
                                            title: "Error",
                                            message: response.response.data,
                                            type: "error"
                                        });
                                        this.loading = false;
                                        this.isSavingInProgress = false;
                                    });
                            } else {
                                return false;
                            }
                        } else {
                            api
                                .saveTicket(sendEmail, this.form, this.serviceTicketNumber)
                                .then(() =>
                                {
                                    if (!this.isCopy)
                                    {
                                        this.$notify({
                                            title: this.$t('common.success'),
                                            message: this.$t('common.ticketSuccessfullySaved'),
                                            type: "success"
                                        });
                                        this.closeDialog();
                                    }
                                    else
                                    {
                                        this.$notify({
                                            title: this.$t('common.success'),
                                            message: this.$t('common.ticketSuccessfullySaved'),
                                            type: "success"
                                        });
                                        api.getServiceTicketNumber().then(response =>
                                        {
                                            this.serviceTicketNumber = response.data.data;
                                        });
                                        api.getComplaintCodeCategories().then(response =>
                                        {
                                            this.form.categories = response.data
                                        });
                                        this.form.status = undefined;
                                        this.form.equipmentId = undefined;
                                        this.form.categoryName = undefined;
                                        this.form.equipmentName = undefined;
                                        this.form.subCategoryName = undefined;
                                        this.form.overtimeApproved = undefined;
                                        this.form.isConfirmationOnly = false;
                                        this.form.urgency = undefined;
                                        this.form.notes = "";
                                        this.form.status = undefined;
                                        this.form.serviceCoverage = undefined;
                                        this.form.complaintCodes = [];
                                        this.form.attachments = [];
                                        this.form.subCategories = [];
                                        this.form.responseTime = -1;
                                        this.isSavingInProgress = false;
                                        this.isCopy = false;

                                        this.scrollToElement({ behavior: 'smooth' });
                                    }
                                   
                                })
                                .catch(response => {
                                    this.$notify({
                                        title: "Error",
                                        message: response.response.data,
                                        type: "error"
                                    });
                                    this.loading = false;
                                    this.isSavingInProgress = false;
                                });
                            
                        }
                    }
                    else {
                        return false;
                    }
                });
            },
            close() {
                this.$refs["form"].validate(valid => {
                    if (valid) {
                        this.loading = true;
                        this.form.status = this.form.status || "1"; // service ticket opened value
                        api
                            .saveTicket(null, this.form, this.serviceTicketNumber)
                            .then(() => {
                                this.closeDialog();
                            })
                            .catch(response => {
                                this.$notify({
                                    title: "Error",
                                    message: response.response.data,
                                    type: "error"
                                });
                                this.loading = false;
                            });
                    } else {
                        return false;
                    }
                });
            },
            attachmentChanged(file, fileList) {
                this.form.attachments.push(file.raw);
            },
            handlePreview(file) {
                var split = file.name.split(".");
                var fileExtension = split[split.length - 1];
                if (!file.url) {
                    return;
                }
                if (fileExtension !== "pdf") {
                    window.open(file.url);
                    return;
                }
                this.fileUrlPreview = file.url;
                this.showImagePreview = true;
            },
            getServiceCompanyCredentials() {
                if (this.form && this.form.customerId) {
                    this.loadingChangeEmail = true;
                    api
                        .getServiceCompanyCredentials(this.form.customerId)
                        .then(response => {
                            this.formChangeEmail.email = response.data.email;
                            this.formChangeEmail.phone = response.data.phone;
                            this.formChangeEmail.serviceCompany = response.data.serviceCompany;
                            this.loadingChangeEmail = false;
                        });
                }
            },
            copyAndSave()
            {
                this.saveHandle();
                this.isCopy = true;
            },
            handleDialogClose() {
                this.showDuplicateTicketWarning = false;
            },
            handleDialogCancel() {
                this.showDuplicateTicketWarning = false;
                this.closeDialog();
            },
            handleDialogContinue() {
                this.showDuplicateTicketWarning = false;
                this.showEmailDialog();
            },
            saveHandle()
            {
                const days = 10;
                api.getOpenedServiceTicketForEquipmentInLastXDays(this.form.equipmentId, days)
                   .then(response => {
                        if (response.data) {
                            this.existingTicketId = response.data.id;
                            this.existingTicketDate = response.data.raisedOn;
                            this.showDuplicateTicketWarning = true;
                        } else {
                            this.showEmailDialog();
                        }
                   });
            },
            showEmailDialog()
            {
                if (this.form.complaintCodes.length === 0) {
                    this.$message.error(this.$t('common.atLeastOneSymptomCodeShouldBeAdded'));
                    return;
                }
                this.$refs["form"].validate(valid => {
                    if (valid) {
                        this.showSaveDialog = true;
                    } else {
                        return false;
                    }
                });
            },
            editFinished() {
                this.ticketToEdit = null;
                this.dialogVisible = false;
            },
            editTicket(id) {
                this.ticketToEdit = id;
                this.dialogVisible = true;
            },
            viewrsprocedures() {
                window.open(
                    "static/RS Procedure Technical Support.pdf",
                    "_blank",
                    "width=600,height=800,toolbar=1"
                );
                this.showRsMessage = false;
            },
            equipmentSelected(equipment) {
                this.equipmentWrtEnd = equipment.warrantyEndFormatted;
                this.form.equipmentName = equipment.model;
                this.form.equipmentNote = equipment.modelNote;
            },
            getMorePreviousTickets() {
                if ((this.currentPreviousTicketsPage * this.previousTicketsPageSize) < this.previousTicketsTotal) {
                    api.getPreviousTickets(this.form.equipmentId, this.currentPreviousTicketsPage + 1, this.previousTicketsPageSize).then(response => {
                        if (response.data.items.length > 0) {
                            this.currentPreviousTicketsPage = this.currentPreviousTicketsPage + 1;
                            this.previousTickets = [...this.previousTickets, ...response.data.items];
                            this.previousTicketsTotal = response.data.total;

                            if (response.data.items.length < this.previousTicketsPageSize || (this.currentPreviousTicketsPage * this.previousTicketsPageSize) === this.previousTicketsTotal) {
                                this.previousTicketsButtonDisabled = true;
                            }
                        }
                        else {
                            this.previousTicketsButtonDisabled = true;
                        }
                    });
                }
                else {
                    this.previousTicketsButtonDisabled = true;
                }
            }
        },
        mounted()
        {
            this.loading = true;
            api.getServiceTicketNumber().then(response => {
                this.loading = false;
                this.serviceTicketNumber = response.data.data;
            });
            api.getComplaintCodeCategories().then(response => {
                this.loading = false
                this.form.categories = response.data
            });  
        }
    };
</script>

<style scoped>
    .full-width,
    .code {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// ClientApp/app/servicetickets/components/CreateServiceTicketDialog.vue